// Need to use the React-specific entry point to import createApi
import { createApi } from '@reduxjs/toolkit/query/react'
import customBaseQuery, { customCloudBaseQuery } from './livoxBaseQuery'

// Define a service using a base URL and expected endpoints
export const livoxApi = createApi({
  reducerPath: 'livoxApi',
  baseQuery: customBaseQuery,
  tagTypes: ['Stripe'],
  keepUnusedDataFor: 0,
  refetchOnMountOrArgChange: true,
  endpoints: () => ({}),
})

export const cloudApi = createApi({
  reducerPath: 'cloudApi',
  baseQuery: customCloudBaseQuery,
  tagTypes: ['Stripe'],
  keepUnusedDataFor: 0,
  refetchOnMountOrArgChange: true,
  endpoints: () => ({}),
})
